<template>
  <page-loader v-if="loadStatus == 'loading'" />
  <div v-else class="contain-section">
    <div class="row">
      <div class="col-12">
        <div class="classical-ancestry-menu">
          <div :class="filter === 'overview' ? 'selected' : ''" @click="setFilter('overview')">
            Overview
          </div>
          <div :class="filter === 'result' ? 'selected' : ''" @click="setFilter('result')">
            Result
          </div>
          <div :class="filter === 'map' ? 'selected' : ''" @click="setFilter('map')">
            Map
          </div>
          <div :class="filter === 'references' ? 'selected' : ''" @click="setFilter('references')">
            References
          </div>
        </div>
      </div>
    </div>
    <div v-if="filter == 'overview'" class="row">
      <div class="col-sm-12 col-md-12 col-lg-7 col-xl-8 my-3">
        <div class="inner-box">
          <div class="banner-box">
            <img class="rounded-4 h-400 img-row-feedback" :src="overview && overview.main_image
              ? overview.main_image[0].url
              : ''
              " alt="Logo" />
          </div>
          <div class="inner-content">
            <h3 class="mb-3 mt-0 ml-0">
              {{ overview ? overview.heading : "" }}
            </h3>
            <div v-html="overview ? overview.text : ''"></div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-5 col-xl-4 my-3">
        <div class="right-bar">
          <div class="population-group p-0 classical-row-population-container">
            <div class="result-detail">
              <div class="left">
                <h4>
                  {{
                    overview?.right_section &&
                      overview.right_section.length > 0
                      ? overview.right_section[0].heading
                      : ""
                  }}
                </h4>
                <div class="m-0 mb-2" v-html="overview?.right_section &&
                  overview.right_section.length > 0
                  ? overview.right_section[0].text
                  : ''
                  "></div>
                <div @click="setFilter('result')" class="load-btn m-auto">
                  {{
                    overview?.right_section &&
                      overview.right_section.length > 0
                      ? overview.right_section[0].button_text
                      : ""
                  }}
                </div>
              </div>
              <div class="percentage-area roman-chart">
                <DoughnutChart v-if="result?.romans?.index" :chart-data="chartData" :options="options"
                  :ChartColor="getClassicalColour('roman')" :centerTitle="result?.romans?.index?.toFixed(2)"
                  centerSubtitle="" chartWidth="100%" chartHeight="100%" />
              </div>
            </div>
          </div>
          <div class="population-group">
            <h4>
              {{
                overview?.right_section && overview.right_section.length > 0
                  ? overview.right_section[1].heading
                  : ""
              }}
            </h4>
            <div v-html="overview?.right_section && overview.right_section.length > 0
              ? overview.right_section[1].text
              : ''
              "></div>
            <img :src="overview?.right_section && overview.right_section.length > 0
              ? overview.right_section[1].main_image[0].url
              : ''
              " />
            <div @click="setFilter('map')" class="load-btn m-auto">
              {{
                overview?.right_section && overview.right_section.length > 0
                  ? overview.right_section[1].button_text
                  : ""
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <RomanReferences v-if="filter == 'references'" :reference="reference" />
    <RomanMap :introduction="introduction" :sample-group="sampleGroup" :sample-sites="sampleSites"
      v-if="filter == 'map'" />
    <RomanResult v-if="filter == 'result'" @action="action" />
  </div>
</template>
<script setup>
import DoughnutChart from "@/components/charts/Doughnut.vue";
import "../../../../styles/pages/ancentry/recent-ancetry.scss";
import { ref, provide, computed, onMounted } from "vue";
import RomanResult from "./RomanResult.vue";
import RomanMap from "./RomanMap.vue";
import RomanReferences from "./RomanReferences.vue";
import {
  getClassicalRomanOverview,
  getClassicalRomanReference,
} from "@/services/classical";
import {
  getRequiredContent,
  getClassicalColour,
} from "@/composables/useClassicalContent";
import store from "@/store/index";

let filter = ref("overview");
const result = store.getters.result;
provide("roman-result", result);

const introduction = ref({});
const sampleGroup = ref({});
const sampleSites = ref({});
const loadStatus = ref("loading");
const overview = ref({});
const reference = ref({});

onMounted(async () => {
  overview.value = await getClassicalRomanOverview();
  reference.value = await getClassicalRomanReference();
  loadStatus.value = "loaded";
});

const action = () => {
  setFilter("map");
};

getRequiredContent([
  "roman-introduction",
  result.romans?.closest_sample.slug,
  "sample-site-locations",
])
  .then(([introductionResult, sampleGroupResult, sampleSitesResult]) => {
    introduction.value = introductionResult;
    sampleGroup.value = sampleGroupResult;
    sampleSites.value = sampleSitesResult;
  })
  .finally();

const setFilter = (filterValue) => {
  filter.value = filterValue;
};
const options = {
  cutout: "70%",
  radius: "100%",
  responsive: true,
  maintainAspectRatio: true,
};

const chartData = computed(() => ({
  cutoutPercentage: 10,
  datasets: [
    {
      data:
        result?.romans?.index <= 100
          ? [result?.romans?.index, 100 - result?.romans?.index]
          : [100, 0],
      backgroundColor: [getClassicalColour("roman"), "#ddd"],
    },
  ],
  labels: [],
}));
</script>
